import { Button, Typography } from "@mui/material";

import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import React from 'react';

const CancelButton = ({ handleClick, disable, label, buttonStyle, fontStyle, toLink }) => {
    return (
        <div>
            <Button
                disabled={disable}
                size="small"
                sx={disable ?
                    {
                        pading: '3px',
                        marginLeft: '15px',
                        borderRadius: "2px",
                        height: "30px",
                        background: '#2C314C',
                        borderColor: '#888FA0',
                    } :
                    {
                        pading: '3px',
                        marginLeft: '15px',
                        borderRadius: "2px",
                        height: "30px",
                        width:'100px',
                        background: '#2C314C',
                        borderColor: '#6378CA',
                        ':hover': {
                            background: '#2C314C',
                            borderColor: '#3D58BD',
                        }
                    }}
                style={buttonStyle}
                variant="outlined"
                onClick={handleClick}
                LinkComponent={Link}
                to={toLink}
            >
                <Typography
                    sx={disable?{ color: "rgba(255, 255, 255, 0.38)", fontFamily: 'Lato', fontWeight: "400", fontSize: "12px", lineHeight: "16px"}:{ color: "#E6E7EB", fontFamily: 'Lato', fontWeight: "400", fontSize: "12px", lineHeight: "16px"}}
                    style={fontStyle}
                >
                    {label}
                </Typography>
            </Button>
        </div>
    )
}
CancelButton.propTypes = {
    handleClick: PropTypes.func,
    disable: PropTypes.bool,
    label: PropTypes.string,
    buttonStyle: PropTypes.any,
    fontStyle: PropTypes.any,
    toLink: PropTypes.any

}
export default CancelButton;